// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"029598fc","239":"9a569f09","455":"d164ee77","972":"3757136a"}[chunkId] + ".chunk.js";
};